import { openDB } from "idb";

export const saveMessageTemplate = async (values) => {
  const db = await openDB("message_templates", 2, {
    upgrade(db) {
      db.createObjectStore("messages", {
        keyPath: "id",
      });
    },
  });

  console.log("Message template saved in IndexedDB", values);

  await db.put("messages", values);
  console.log("Message template saved in IndexedDB");
};

export const getMessageTemplates = async () => {
  const db = await openDB("message_templates", 1);
  const messages = await db.getAll("messages");
  return messages;
};
